import styled from "styled-components";

export const CostDisplayComponent = styled.div<{
    fontSize: number,
    backgroundColor: string,
    textColor: string,
}>`
  display: flex;
  width: fit-content;
  align-items: center;
  font-weight: 500;
  vertical-align: middle;
  font-size: ${({ fontSize }) => fontSize}px;
  color: ${({ textColor }) => textColor};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 10px;
  padding: 12px 20px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
  margin: 10px;
`
